// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"W6Fsj7xt2IREOOEC"};